import { differenceInCalendarDays, parse } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { formatDate } from 'lib/helpers/dateUtils';
import { iaRa } from 'lib/helpers/utility';

export const formatDateHeader = (dateString, timezone) => {
  if (!dateString) return '';
  const now = timezone ? toZonedTime(new Date(), timezone) : new Date();
  const dateToFormat = timezone
    ? toZonedTime(new Date(dateString), timezone)
    : new Date(dateString);
  const diffInDays = differenceInCalendarDays(now, dateToFormat);

  if (diffInDays === 0) {
    return 'Today';
  }

  if (diffInDays === 1) {
    return 'Yesterday';
  }

  return formatDate(dateString, timezone, 'MMMM d, yyyy');
};

export const groupActivitiesByDate = (activities, timezone) => {
  const grouped = {};
  const dateKeys = [];

  iaRa(activities).forEach((activity) => {
    const dateKey = formatDate(activity.created_at, timezone, 'MM/dd/yyyy');

    if (!dateKey) return;

    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
      dateKeys.push(dateKey);
    }
    grouped[dateKey].push(activity);
  });

  // Sort date keys in ascending order (oldest first)
  // Parse dates to compare properly (MM/DD/YYYY format)
  dateKeys.sort((a, b) => {
    const dateA = parse(a, 'MM/dd/yyyy', new Date());
    const dateB = parse(b, 'MM/dd/yyyy', new Date());
    return dateA.getTime() - dateB.getTime();
  });

  return { grouped, dateKeys };
};
